module.exports = __webpack_public_path__ + "img/google-pay-mark_800.9f4ad6b2.svg";